export default __webpack_public_path__ + "assets/bg1.87e50b35.png";